module.exports = __webpack_public_path__ + "static/media/depositScreen.757f27f4.png";